import styled from 'styled-components'

export const Main = styled.main`
    flex: 1;
    background: #eef3fb;
    border-radius: 18px;
    padding: 20px;
    min-height: 500px;
    box-shadow: inset 0 0 0 1px #d8e3f2;
    overflow: hidden;
`

export const Panel = styled.div`
    margin: 20px 0;
    padding: 22px;
    border-radius: 18px;
    background: #ffffff;
    border: 1px solid #dde6f3;
    box-shadow: 0 3px 10px rgba(42, 76, 129, 0.12);
`

export const FormHeader = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 18px;
`

export const FormTitle = styled.h2`
    margin: 0;
    font-size: 22px;
    color: #355486;
`

export const FormSubtitle = styled.p`
    margin: 6px 0 0;
    font-size: 14px;
    color: #6b7fa3;
`

export const FormGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
    gap: 16px;
`

export const FormField = styled.label`
    display: flex;
    flex-direction: column;
    gap: 7px;
    font-size: 14px;
    font-weight: 600;
    color: #39598a;
`

export const FormSelect = styled.select`
    padding: 11px 12px;
    border: 1px solid #cfd9ea;
    border-radius: 12px;
    background: #f8fbff;
    color: #2f4c7d;
    font-size: 15px;
    outline: none;

    &:focus {
        border-color: #4a6fb0;
        background: #ffffff;
        box-shadow: 0 0 0 4px rgba(74, 111, 176, 0.15);
    }
`

export const CheckboxRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 48px;
`

export const FormActions = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    padding-top: 18px;
    border-top: 1px solid #e7edf7;
    gap: 12px;
    flex-wrap: wrap;
`

export const ActionButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 22px;
    border: none;
    border-radius: 14px;
    cursor: pointer;
    background: linear-gradient(135deg, #4a6fb0, #355486);
    color: white;
    font-size: 15px;
    font-weight: 700;
    box-shadow: 0 6px 14px rgba(53, 84, 134, 0.28);
    transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;

    &:hover:not(:disabled) {
        transform: translateY(-1px);
        box-shadow: 0 9px 18px rgba(53, 84, 134, 0.34);
    }

    &:disabled {
        opacity: 0.65;
        cursor: not-allowed;
        box-shadow: none;
    }
`

export const ActionButtonIcon = styled.span`
    font-size: 18px;
    line-height: 1;
`

export const ErrorBox = styled.div`
    margin-bottom: 16px;
    background: #fff;
    border-left: 5px solid #d9534f;
    color: #b02a37;
    border-radius: 12px;
    padding: 14px 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`

export const NoticeBox = styled.div`
    margin-bottom: 16px;
    background: #fff;
    border-left: 5px solid #4a8f5b;
    color: #2f6b3d;
    border-radius: 12px;
    padding: 14px 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`

export const StateBox = styled.div`
    background: white;
    border-radius: 14px;
    padding: 18px;
    color: #2f4c7d;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`

export const TableWrapper = styled.div`
    width: 100%;
    overflow-x: auto;
    background: white;
    border-radius: 16px;
    box-shadow: 0 3px 10px rgba(42, 76, 129, 0.12);
    border: 1px solid #dde6f3;
`

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    min-width: 800px;

    thead {
        background: #dfe9f8;
    }

    th {
        padding: 14px 16px;
        text-align: left;
        font-size: 15px;
        color: #355486;
        border-bottom: 1px solid #cfd9ea;
        white-space: nowrap;
    }

    td {
        padding: 14px 16px;
        font-size: 14px;
        color: #2f4c7d;
        border-bottom: 1px solid #e7edf7;
        vertical-align: top;
    }

    tbody tr:hover {
        background: #f8fbff;
    }
`

export const RightCell = styled.td`
    text-align: right;
`

export const ViewButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 8px 16px;
    border: none;
    border-radius: 12px;
    cursor: pointer;
    background: linear-gradient(135deg, #4a6fb0, #355486);
    color: #ffffff;
    font-size: 14px;
    font-weight: 700;
    box-shadow: 0 4px 10px rgba(53, 84, 134, 0.25);
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 7px 14px rgba(53, 84, 134, 0.3);
    }
`

export const Counter = styled.span`
    align-self: center;
    background: #dfe9f8;
    color: #355486;
    font-weight: 700;
    font-size: 14px;
    padding: 6px 12px;
    border-radius: 12px;
    white-space: nowrap;
`

export const ActiveRow = styled.tr`
    background: #eef3fb;

    &:hover {
        background: #eef3fb;
    }
`

export const PreviewSection = styled.div`
    margin-top: 20px;
    padding-top: 18px;
    border-top: 1px solid #e7edf7;
`

export const PreviewHeader = styled.div`
    font-size: 18px;
    font-weight: 700;
    color: #355486;
    margin-bottom: 12px;
`

export const PreviewSub = styled.span`
    font-size: 14px;
    font-weight: 600;
    color: #6b7fa3;
`

export const PreviewMeta = styled.div`
    margin-bottom: 12px;
    font-size: 14px;
    color: #4a6fb0;
    font-weight: 600;
`

export const TablePicker = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;

    label {
        font-size: 14px;
        font-weight: 700;
        color: #39598a;
    }

    select {
        width: auto;
        min-width: 220px;
        padding: 12px 14px;
        border-radius: 12px;
        border: 1px solid #cfd9ea;
        background: white;
        font-size: 16px;
        color: #2d4a78;
        outline: none;
        cursor: pointer;
    }
`
